<script>
export default {
  name: "BackButton",
};
</script>

<template>
  <div
    @click="$router.go(-1)"
    class="mb-10 cursor-pointer text-red-600 text-2xl font-bold"
  >
    <fas icon="angle-double-left" /> Back
  </div>
</template>
